/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTI1p3Provider } from './BaseLTI1p3Provider';
const FinalizedLTI1p3ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['finalized', /* #__PURE__ */ parsers.exactly(true)],
]), BaseLTI1p3Provider);
export class FinalizedLTI1p3Provider extends BaseLTI1p3Provider {
    static decode(input) {
        return FinalizedLTI1p3ProviderParser.decode(input).map(res => new FinalizedLTI1p3Provider(res));
    }
    static unsafeDecode(input) {
        return FinalizedLTI1p3Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FinalizedLTI1p3ProviderParser.encode(data);
    }
    static schema() {
        return FinalizedLTI1p3ProviderParser.schema();
    }
}
